// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductTemplate_productTemplateMain__y8lxm {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* height: 150px; */
    /* background-color: #F7F8FF; */
    margin: 14px 0px;
    display: none;
    /* background: url("../../icons/rectangle.png"); */
    position: relative;
    background-repeat: no-repeat;
    background-position: right;
    border-radius: 13px;
    border: 1px solid black;
}

.ProductTemplate_productTemplateImage__m8hgB {
    /* border: 1px solid red; */
    width: 40%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: cover;



}

.ProductTemplate_productTemplateImage__m8hgB img {
    width: 100%;
    height: 100%;
    /* border: 1px solid rgb(27, 2, 255); */
    object-fit: contain;
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
}

.ProductTemplate_productTemplateDesc__AEHRO {
    width: 75%;
    padding-left: 20px;
    /* display: flex; */
    flex-direction: column;
    justify-content: space-around;
    padding-bottom: 5px;
    /* gap: 6px; */
    /* border: 1px solid rgb(4, 245, 104); */
}

.ProductTemplate_productTemplateDesc__AEHRO button {
    background-color: #02D757;
    border: none;
    outline: none;
    width: 58.94px;
    height: 21.84px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    font-size: 12px;

}

.ProductTemplate_productTemplateDesc__AEHRO p:nth-child(3) {
    color: #4F4F4F;
    font-weight: 800;
    font-size: 14px;
    line-height: 14px;
    padding-bottom: 3px
}

.ProductTemplate_productTemplateDesc__AEHRO p:nth-child(1) {
    color: #4F4F4F;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

}

.ProductTemplate_productTemplateButtons__dGUoN {
    padding-top: 6px;
    display: flex;
    flex-direction: column;
}

.ProductTemplate_approvalStatus__ZdXY5{
    background-color: red !important;
    width: 54.94px !important;
    height: 21.84px !important;

}
.ProductTemplate_pop-up__Pb9Te{
    position: relative;
}
.ProductTemplate_popupClose__-ou1Q{
     position: absolute;
     top: -1px;
     right: 5px;
     color: blue;
     font-weight: 700;
     font-size: 15px;
     cursor: pointer;
}

@media screen and (max-width: 786px) {
    .ProductTemplate_productTemplateMain__y8lxm {
        display: block;
        padding: 5px;
    }
}

@media screen and (max-width: 375px) {

    .ProductTemplate_productTemplateDesc__AEHRO {
        gap: 3px;
    }

    .ProductTemplate_productTemplateDesc__AEHRO p {
        font-size: 12px !important;
    }

    .ProductTemplate_productTemplateImage__m8hgB img {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    .ProductTemplate_productTemplateDesc__AEHRO p:nth-child(3) {
        padding-bottom: 0px
    }

    .ProductTemplate_productTemplateDesc__AEHRO button {
        width: 53.94px;
        height: 17.84px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProductViewTemplate/ProductTemplate.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;;;;AAIrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;;AAE9B;AACA;IACI,kBAAkB;AACtB;AACA;KACK,kBAAkB;KAClB,SAAS;KACT,UAAU;KACV,WAAW;KACX,gBAAgB;KAChB,eAAe;KACf,eAAe;AACpB;;AAEA;IACI;QACI,cAAc;QACd,YAAY;IAChB;AACJ;;AAEA;;IAEI;QACI,QAAQ;IACZ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[".productTemplateMain {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    /* height: 150px; */\n    /* background-color: #F7F8FF; */\n    margin: 14px 0px;\n    display: none;\n    /* background: url(\"../../icons/rectangle.png\"); */\n    position: relative;\n    background-repeat: no-repeat;\n    background-position: right;\n    border-radius: 13px;\n    border: 1px solid black;\n}\n\n.productTemplateImage {\n    /* border: 1px solid red; */\n    width: 40%;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    object-fit: cover;\n\n\n\n}\n\n.productTemplateImage img {\n    width: 100%;\n    height: 100%;\n    /* border: 1px solid rgb(27, 2, 255); */\n    object-fit: contain;\n    border-top-left-radius: 9px;\n    border-bottom-left-radius: 9px;\n}\n\n.productTemplateDesc {\n    width: 75%;\n    padding-left: 20px;\n    /* display: flex; */\n    flex-direction: column;\n    justify-content: space-around;\n    padding-bottom: 5px;\n    /* gap: 6px; */\n    /* border: 1px solid rgb(4, 245, 104); */\n}\n\n.productTemplateDesc button {\n    background-color: #02D757;\n    border: none;\n    outline: none;\n    width: 58.94px;\n    height: 21.84px;\n    line-height: 14px;\n    color: white;\n    font-weight: 500;\n    font-size: 12px;\n\n}\n\n.productTemplateDesc p:nth-child(3) {\n    color: #4F4F4F;\n    font-weight: 800;\n    font-size: 14px;\n    line-height: 14px;\n    padding-bottom: 3px\n}\n\n.productTemplateDesc p:nth-child(1) {\n    color: #4F4F4F;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n\n}\n\n.productTemplateButtons {\n    padding-top: 6px;\n    display: flex;\n    flex-direction: column;\n}\n\n.approvalStatus{\n    background-color: red !important;\n    width: 54.94px !important;\n    height: 21.84px !important;\n\n}\n.pop-up{\n    position: relative;\n}\n.popupClose{\n     position: absolute;\n     top: -1px;\n     right: 5px;\n     color: blue;\n     font-weight: 700;\n     font-size: 15px;\n     cursor: pointer;\n}\n\n@media screen and (max-width: 786px) {\n    .productTemplateMain {\n        display: block;\n        padding: 5px;\n    }\n}\n\n@media screen and (max-width: 375px) {\n\n    .productTemplateDesc {\n        gap: 3px;\n    }\n\n    .productTemplateDesc p {\n        font-size: 12px !important;\n    }\n\n    .productTemplateImage img {\n        border-top-left-radius: 14px;\n        border-bottom-left-radius: 14px;\n    }\n\n    .productTemplateDesc p:nth-child(3) {\n        padding-bottom: 0px\n    }\n\n    .productTemplateDesc button {\n        width: 53.94px;\n        height: 17.84px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productTemplateMain": `ProductTemplate_productTemplateMain__y8lxm`,
	"productTemplateImage": `ProductTemplate_productTemplateImage__m8hgB`,
	"productTemplateDesc": `ProductTemplate_productTemplateDesc__AEHRO`,
	"productTemplateButtons": `ProductTemplate_productTemplateButtons__dGUoN`,
	"approvalStatus": `ProductTemplate_approvalStatus__ZdXY5`,
	"pop-up": `ProductTemplate_pop-up__Pb9Te`,
	"popupClose": `ProductTemplate_popupClose__-ou1Q`
};
export default ___CSS_LOADER_EXPORT___;
